import React, { useState, useEffect } from 'react';
import { Viewer, Worker } from '@react-pdf-viewer/core';
import '@react-pdf-viewer/core/lib/styles/index.css';
import { useGetInterviewCandDetailsQuery } from '../../../../../../../features/hiringstages/interviewApiSlice';
import { selectCandidateInterview } from '../../../../../../../features/hiringstages/candidateInterviewSlice';
import { useSelector } from 'react-redux';
import { getPresignedUrl } from '../../../../../../../components/common/getPresignedUrl';

function CandResume() {
  const candId = useSelector(selectCandidateInterview);
  const {
    data: canddetails,
    isLoading,
    isSuccess,
  } = useGetInterviewCandDetailsQuery(candId, {
    refetchOnMountOrArgChange: true,
  });
  // Create new plugin instance
  // const defaultLayoutPluginInstance = defaultLayoutPlugin();
  const fileName = canddetails?.data.fileName
  console.log('resume = ', fileName);
  const [pdfUrl, setPdfUrl] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    async function fetchPdf() {
      setLoading(true);
      const url = await getPresignedUrl(fileName);
      setPdfUrl(url);
      setLoading(false);
    }

    fetchPdf();
  }, [fileName]);


  return (
    <>
      <div style={{ marginTop: "20px", height: "500px" }}>
        {loading ? (
          <p>Loading PDF...</p>
        ) : pdfUrl ? (
          <iframe src={pdfUrl} width="100%" height="100%" style={{ border: "none" }} />
        ) : (
          <p style={{ color: "red", textAlign: "center", backgroundColor: "whitesmoke" }}>
            ❌ No file found
          </p>
        )}
      </div>
    </>
  );
}

export default CandResume;
